<script>
  import ActionReportMixin from './ActionReportMixin.vue'

  export default {
    name: 'RbvHotelRfpBidManagerSetContactActionReport',
    mixins: [ ActionReportMixin ],
    data () {
      return {
        messages: {
          'OK': 'Contact set',
          'NOT_FOUND': 'Contact not saved - Bid Deleted',
          'STATUS_CHANGED': 'Contact not saved - Bid Changed',
          'ERROR': 'Contact not saved'
        }
      }
    },
    computed: {
      title () { return this.items.length === 1 ? 'Contact not saved!' : 'Failed to save contact to some bids!' },
      message () {
        return this.items.length === 1
          ? 'We were not able to save contact because of the reason listed below:'
          : `${this.items.length - this.failures} of ${this.items.length} bids have their contact updated successfully.<br /> We were not able to update contact on all bids because of the reasons listed below:`
      }
    }
  }
</script>
